export default __webpack_public_path__ + "static/media/ear_prop.c798dd34.svg";